/**
 * Language Toggle Component
 *
 * Allows switching between English and French
 */

import { cn } from "@/lib/utils";
import { useLanguage } from "../i18n";

export interface LanguageToggleProps {
  className?: string;
}

export function LanguageToggle({ className }: LanguageToggleProps) {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <button
        type="button"
        onClick={() => setLanguage("en")}
        className={cn(
          "px-2 py-1 text-sm font-condensed uppercase tracking-wide transition-all",
          language === "en"
            ? "bg-bb-gold text-bb-black font-semibold"
            : "bg-transparent text-bb-bone-white/60 hover:text-bb-bone-white border border-bb-gray-mid hover:border-bb-gold"
        )}
        aria-label="English"
        aria-pressed={language === "en"}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLanguage("fr")}
        className={cn(
          "px-2 py-1 text-sm font-condensed uppercase tracking-wide transition-all",
          language === "fr"
            ? "bg-bb-gold text-bb-black font-semibold"
            : "bg-transparent text-bb-bone-white/60 hover:text-bb-bone-white border border-bb-gray-mid hover:border-bb-gold"
        )}
        aria-label="Français"
        aria-pressed={language === "fr"}
      >
        FR
      </button>
    </div>
  );
}
